import React from "react";
import styles from "./styles.css";
import clock from "./images/clock.svg";
import PropTypes from "prop-types";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import { VERIFIED_STATUS } from "../../../constants/verification-constants";

import error from "./images/error.svg";
import verified from "./images/tick.svg";

const PostBcDepositPaidSection = ({
    deposit = {}

}) => {
    const { amount = 0, info: { status, text, subText } = {}} = deposit || {};
    const renderStatus = () => {
        switch (status) {
        case VERIFIED_STATUS.VERIFYING:
            return (
                <div styleName={"styles.verifyingWrap"}>
                    <img src={clock} alt="verifying" />
                    <p styleName={"styles.verifyText"}>{text}</p>
                </div>
            );

        case VERIFIED_STATUS.FAILED:
            return (
                <div styleName={"styles.notVerifiedContainer"}>
                    <div styleName={"styles.notVerifyingWrap"}>
                        <img src={error} alt="not verified" />
                        <p styleName={"styles.verifyText"}>{text}</p>
                    </div>
                    <p styleName={"styles.notVerifyDetail"}>
                        {subText}
                    </p>
                </div>
            );

        case VERIFIED_STATUS.VERIFIED:
            return (
                <div styleName={"styles.verifiedWrap"}>
                    <img src={verified} alt="verified" />
                    <p styleName={"styles.verifyText"}>{text}</p>
                </div>
            );

        default:
            return null;
        }
    };
    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.headerWrapper"}>
                <p styleName={"styles.deposit"}>Deposit paid</p>
                <p styleName={"styles.amount"}>{makePriceLabelRound(amount)}</p>
            </div>
            {renderStatus()}
        </div>
    );
};
PostBcDepositPaidSection.propTypes = {
    paymentSummaryData: PropTypes.object,
    updatePaymentSummaryStatusConnect: PropTypes.func,
    orderId: PropTypes.string
};

PostBcDepositPaidSection.propTypes = {
    deposit: PropTypes.number.isRequired
};

export default PostBcDepositPaidSection;
